<style lang="scss" scoped>
@use '~@/styles/main';
@use '~@/styles/base/variables';
$padding-for-mobile-bottom-panel: 50px;

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.main {
  background-color: #404364;
  border-radius: 5px;

  &_mobile {
    .content {
      display: none;
    }
  }
}

.input_error {
  ::v-deep {
    .ivu-input {
      border: 1px solidvar(--color-danger-light);
    }
  }
}

.header {
  position: sticky;
  top: 0px;
  padding: 2rem 1.6rem;
  background-color: #404364;
  z-index: 2;
  border-bottom: 1px solid #2a2f44;
  display: flex;
  align-items: center;
  gap: 4rem;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;

  &__id {
    color: #7d68ff;
    font-size: 1.6rem;
  }

  &__right-item {
    margin-left: auto;
  }
}

.btn {
  &_text {
    color: #7d68ff;
    font-weight: 600;
  }

  &__content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2px;
  }

  &_add {
    margin-bottom: 1rem;
  }
}

.tag {
  $close-width: 24px;

  position: relative;
  display: inline-block;
  border: 1px solid var(--color-background);
  border-radius: 3px;
  padding: 2px $close-width 2px 8px;
  margin: 2px 4px 2px 0;

  &__exchName {
    color: lightgray;
    margin-left: 2px;
    margin-right: 2px;
  }

  &__close {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: $close-width;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #323232;

    &:hover {
      color: #ffffff;
    }
  }

  &_default {
    background-image: linear-gradient(to bottom left, var(--color-accent-dark), var(--color-accent));
  }

  &_demo {
    background: var(--color-success-light);
  }
}

.radio-label {
  // reduce iview styles
  font-size: 12px !important;
  padding: 0 5px !important;
  text-align: center;
  width: 33px;
}

.content {
  display: flex;
  justify-content: space-evenly;
  column-gap: 1rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
  font-size: 1.4rem;

  .right-side {
    margin-top: -1rem;
  }

  .gap {
    margin-top: 5rem;
  }

  .item {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1rem;

    &__left {
      width: 23rem;
      text-align: left;
      text-transform: uppercase;
    }

    &__right {
      text-align: left;
      width: 20rem;
    }

    &_exchange {
      align-items: flex-start;
      min-height: 6rem;
    }

    &_id-wrapper {
      display: none;

      .id {
        font-size: 16px;
        color: #7d68ff;
      }
    }

    .trail {
      display: flex;
      align-items: center;
      min-height: 24px;
      gap: 4px;

      &__pct {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 2px;
      }
    }

    .url {
      font-weight: bold;
      color: #ffffff;
    }

    .tp-grid {
      grid-template-columns: repeat(2, calc(50% - 1rem));
      display: grid;
      text-align: left;
      column-gap: 2rem;
      row-gap: 1rem;
      justify-content: flex-start;
    }

    .message {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre;
      font-weight: bold;
      background: #1d2040;
      border-radius: 4px;
      padding: 1rem;
      margin-right: 1rem;
      text-transform: none;
    }

    /* fix */
    .radio-groop {
      label {
        width: 50%;
      }
    }
  }
}

@media screen and (max-width: variables.$large) {
  .content {
    .item__left {
      width: 18rem;
    }
  }
}

@media screen and (max-width: variables.$standart) {
  .header {
    padding: 1rem 1rem;
  }

  .content {
    .item__left {
      width: 16rem;
    }

    .item__right {
      width: 16rem;
    }
  }
}

@media screen and (max-width: 1050px) {
  .content {
    .item {
      &__left {
        width: 14rem;
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  .content {
    flex-wrap: wrap;
    width: 90%;
    margin-left: auto;
    margin-right: auto;

    .left-side {
      width: 100%;
    }

    .right-side {
      width: 100%;

      & > :first-child {
        margin-top: 1rem;
      }
    }

    .gap {
      margin-top: 0;
    }

    .item {
      &__left {
        width: 100%;
      }

      &__right {
        width: 100%;
      }
    }
  }
}

@media screen and (max-width: variables.$small) {
  .header {
    position: fixed;
    width: calc(100% - 85px);
    bottom: 0;
    top: unset;
    justify-content: center;
    align-items: stretch;
    box-shadow: 0 -1px 3px #0c0138;
    height: $padding-for-mobile-bottom-panel;
    padding: 10px;

    & > * {
      flex: 1 1 auto;
    }

    &__id {
      display: none;
    }

    &__right-item {
      margin-left: unset;
    }
  }

  .content {
    margin: 0 auto;
    padding-bottom: $padding-for-mobile-bottom-panel;
    padding-top: 10px;
  }

  .item_id-wrapper {
    display: flex !important;
  }
}

@media screen and (max-width: variables.$xs) {
  .header {
    gap: 2rem;
    height: 55px;
    width: 100%;
    margin-bottom: 64px;
  }
  .content {
    .item {
      &__left {
        width: 18rem;
      }

      &__right {
        ::v-deep .ivu-radio-wrapper {
          font-size: 1rem;
          padding: 0;
        }
      }

      &__btns {
        width: 8rem;
      }
    }
  }
}
</style>

<template>
  <main
    class="main"
    :class="{ main_mobile: $store.state.hooks.showMobileHookList }"
  >
    <header
      class="header"
      v-if="currentHook && currentHook.Params"
    >
      <h4 class="header__id" style="cursor: pointer" @click="$copyToClipboardAndNotify(currentHook.Id)">
        #{{ currentHook.Id }}
      </h4>
      <button
        class="ghost-btn header__right-item"
        :title="$text.tr('Дублировать')"
        @click="duplicateHook()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 18 18"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.23047 0C5.1259 0 4.23047 0.895431 4.23047 2V4H1C0.447715 4 0 4.44772 0 5V17C0 17.5523 0.447716 18 1 18H13C13.5523 18 14 17.5523 14 17V13.7693H15.9999C17.1044 13.7693 17.9999 12.8739 17.9999 11.7693V2C17.9999 0.895432 17.1044 0 15.9999 0H6.23047ZM14 11.7693H15.9999L15.9999 2H6.23047V4H13C13.5523 4 14 4.44772 14 5V11.7693ZM2 16V6H12V16H2Z"
          />
        </svg>
      </button>
      <button
        class="ghost-btn ghost-btn_danger"
        :title="$text.tr('Удалить')"
        @click="removeHook()"
      >
        <Icon type="md-remove" />
      </button>
      <Button
        type="primary"
        size="small"
        long
        style="width: 130px; height: 30px;"
        @click="saveHookChanges()"
        :disabled="!$store.state.hooks.isEditingHook"
      >
        {{ $text.tr('СОХРАНИТЬ') }}
      </Button>
    </header>
    <div
      class="content"
      v-if="currentHook && currentHook.Params"
    >
      <div class="left-side">
        <div class="item item_id-wrapper">
          <label
            class="item__left"
            for="name"
          >
            ID </label>
          <div class="item__right">
            <span class="id">
              {{ currentHook.Id }}
            </span>
          </div>
        </div>
        <div class="item">
          <label
            class="item__left"
            for="name"
          >
            {{ $text.tr('НАЗВАНИЕ') }}</label>
          <i-input
            class="item__right"
            :class="{'input_error': isHookNameEmpty}"
            element-id="name"
            type="text"
            v-model="currentHook.Params.Name"
          />
        </div>
        <div class="item">
          <label
            class="item__left"
            for="amount"
          >
            {{ $text.tr('СУММА В USD') }}</label>
          <CustomInputNumber
            id="amount"
            class="item__right"
            :model.sync="currentHook.Params.Amount"
            :min="minAmount"
            @updateErrorCount="updateErrorCount"
          />
        </div>
        <div class="item">
          <label class="item__left"> {{ $text.tr('НАПРАВЛЕНИЕ') }}</label>
          <RadioGroup
            v-model="currentHook.Params.Side"
            class="item__right radio-groop"
            type="button"
            button-style="solid"
          >
            <Radio
              label="B"
              style="text-align: center;"
            >{{ $text.tr('ПОКУПКА') }}</Radio>
            <Radio
              label="S"
              style="text-align: center;"
            >{{ $text.tr('ПРОДАЖА') }}</Radio>
          </RadioGroup>
        </div>
        <div class="item">
          <label class="item__left"> {{ $text.tr('ВХОД ПО РЫНКУ') }}</label>
          <div class="item__right">
            <i-switch v-model="currentHook.Params.MarketEntry" />
          </div>
        </div>
        <div class="item">
          <label class="item__left"> {{ $text.tr('ТИП МАРЖИ') }}</label>
          <RadioGroup
            v-model="currentHook.Params.MarginType"
            class="item__right radio-groop"
            type="button"
            button-style="solid"
          >
            <Radio
              label="iso"
              style="text-align: center;"
            >ISOLATED</Radio>
            <Radio
              label="cross"
              style="text-align: center;"
            >CROSS</Radio>
          </RadioGroup>
        </div>
        <div class="item">
          <label
            class="item__left"
            for="leverage"
          >
            {{ $text.tr('ПЛЕЧО') }}</label>
          <CustomInputNumber
            id="leverage"
            class="item__right"
            :max="maxLeverage"
            :model.sync="currentHook.Params.Leverage"
            @updateErrorCount="updateErrorCount"
          />
        </div>
        <div class="item item_exchange">
          <div class="item__left">
            <label style="margin-right: 1rem"> {{ $text.tr('БИРЖИ') }}</label>
            <Button
              @click="addAllExchanges()"
              class="btn_text"
              type="text"
              size="small"
            >
              {{ $text.tr('все') }}</Button>
          </div>
          <div class="item__right">
            <transition name="fade">
              <div v-if="currentHook.Params.Etids.length">
                <div
                  v-for="(etid, index) in currentHook.Params.Etids"
                  class="tag"
                  :class="returnExchDemo(etid) ? 'tag_demo' : 'tag_default'"
                  :key="'ex-' + index"
                >
                  <span>{{ returnExchId(etid) }}</span>
                  <span class="tag__exchName">{{ returnExchUserName(etid) }}</span>
                  <Icon
                    class="tag__close"
                    type="md-close"
                    @click="removeExchange(index)"
                  />
                </div>
              </div>
            </transition>
          </div>
        </div>
        <div class="item gap">
          <label
            class="item__left"
            for="shoulder"
          >URL</label>
          <div class="item__right">
            <a
              class="url"
              :href="url"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ url }}
            </a>
            <Button
              @click="copyToClipboard(url)"
              class="btn_text"
              type="text"
              size="small"
            >
              <Icon
                type="md-copy"
                size="18"
              />
            </Button>
          </div>
        </div>
        <div
          class="item__left"
          style="margin-bottom: 1rem"
        >
          {{ $text.tr('СООБЩЕНИЕ') }}
        </div>
        <div class="item">
          <div class="item__left message">
            {{ message }}
          </div>
          <div class="item__right item__btns">
            <Button
              @click="copyToClipboard(message)"
              style="margin-right: 1rem"
              class="btn_text"
              type="text"
            >
              <Icon
                type="md-copy"
                size="24"
              />
            </Button>
            <!-- <Button
              class="btn_text"
              type="text"
            >COPY FULL</Button> -->
          </div>
        </div>
        <div class="item">
          <i-input
            class="item__left"
            type="text"
            v-model="ticker"
            placeholder="введите тикер"
          />
          <div class="item__right item__btns">
            <Button
              icon="md-send"
              style="width: 4rem"
              @click="sendTicker()"
              long
            />
          </div>
        </div>
        <!-- <div class="item">
          <span class="item-left"> { response } </span>
        </div> -->
      </div>
      <div class="right-side">
        <div
          class="item"
          style="margin-bottom: 0"
        >
          <!-- fake item -->
          <label class="item__left"></label>
          <div class="item__right"></div>
        </div>
        <div>
          <Button
            @click="clearSetka()"
            class="btn_text btn_add"
            type="text"
          >
            <div class="btn__content">
              <Icon :type="showSetka ?  'md-remove' : 'md-add'" />
              <span>{{ $text.tr('СЕТКА') }}</span>
            </div>
          </Button>
        </div>
        <transition name="fade">
          <div v-if="showSetka">
            <div class="item">
              <label
                class="item__left"
                for="qty"
              >
                {{ $text.tr('КОЛ-ВО ВХОДОВ') }}</label>
              <CustomInputNumber
                id="qty"
                class="item__right"
                :model.sync="currentHook.Params.Setka.Qty"
                :max="maxSetkaQty"
                @updateErrorCount="updateErrorCount"
              />
            </div>
            <div class="item">
              <label
                class="item__left"
                for="mul"
              >
                {{ $text.tr('МНОЖИТЕЛЬ') }}</label>
              <CustomInputNumber
                id="mul"
                class="item__right"
                :model.sync="currentHook.Params.Setka.Mul"
                @updateErrorCount="updateErrorCount"
              />
            </div>
            <div class="item">
              <label
                class="item__left"
                for="setka-step"
              >
                {{ $text.tr('ШАГ В %') }}</label>
              <CustomInputNumber
                id="setka-step"
                class="item__right"
                :model.sync="currentHook.Params.Setka.Step"
                :max="100"
                @updateErrorCount="updateErrorCount"
              />
            </div>
          </div>
        </transition>
        <div>
          <Button
            @click="clearStopLoss()"
            class="btn_text btn_add"
            type="text"
          >
            <div class="btn__content">
              <Icon :type="showStopLoss ?  'md-remove' : 'md-add'" />
              <span>STOP LOSS</span>
            </div>
          </Button>
        </div>
        <transition name="
              fade">
          <div v-if="showStopLoss">
            <div class="item">
              <label
                class="item__left"
                for="sl-step"
              >
                {{ $text.tr('ОТ ВХОДА %') }}</label>
              <CustomInputNumber
                id="sl-step"
                class="item__right"
                :model.sync="currentHook.Params.Sl.Step"
                :max="100"
                @updateErrorCount="updateErrorCount"
              />
            </div>
            <div class="item">
              <label
                class="item__left"
                for="timeout"
              >
                {{ $text.tr('ТАЙМАУТ В СЕК') }}</label>
              <CustomInputNumber
                id="timeout"
                class="item__right"
                :model.sync="currentHook.Params.Sl.Timeout"
                @updateErrorCount="updateErrorCount"
              />
            </div>
            <div class="item">
              <label
                class="item__left"
                for="slcPeriod"
              >
                {{ $text.tr('ЗАКРЫТИЕ СВЕЧИ') }}
              </label>
              <RadioGroup
                id="slcPeriod"
                class="item__right"
                v-model="currentHook.Params.Sl.SlcPeriod"
                type="button"
              >
                <Radio
                  v-for="(period, index) in slcPeriods"
                  :key="'slc-period_' + index"
                  :label="period.min"
                  class="radio-label"
                >{{ period.interval }}</Radio>
              </RadioGroup>
            </div>
            <div class="item">
              <label class="item__left"> {{ $text.tr('TRAIL') }}</label>
              <div class="item__right trail">
                <i-switch v-model="currentHook.Params.Sl.Trail" />
              </div>
            </div>
          </div>
        </transition>
        <div>
          <Button
            @click="clearTakeProfit"
            class="btn_text btn_add"
            type="text"
          >
            <div class="btn__content">
              <Icon :type="showTakeProfit ?  'md-remove' : 'md-add'" />
              <span>TAKE PROFIT</span>
            </div>
          </Button>
        </div>
        <transition name="fade">
          <div v-if="showTakeProfit">
            <div class="item">
              <label class="item__left"> {{ $text.tr('TRAIL') }}</label>
              <div class="item__right trail">
                <i-switch
                  v-model="currentHook.Params.Tp.Trail"
                  @on-change="onChangeTpTrail()"
                />
                <div
                  v-show="currentHook.Params.Tp.Trail"
                  class="trail__pct"
                >
                  <CustomInputNumber
                    ref="trailPct"
                    :model.sync="currentHook.Params.Tp.TrailPct"
                    :max="100"
                    style="margin-right: 2px;"
                    @updateErrorCount="updateErrorCount"
                    small
                  />
                  <span>%</span>
                </div>
              </div>
            </div>
            <div class="item">
              <label
                class="item__left"
                for="quantity"
              >
                {{ $text.tr('КОЛ-ВО') }}</label>
              <CustomInputNumber
                id="quantity"
                class="item__right"
                :model.sync="ordersLength"
                :max="maxTakeProfitQty"
                @updateErrorCount="updateErrorCount"
              />
            </div>
            <div class="item">
              <label class="item__left"></label>
              <div class="item__right tp-grid">
                <span v-visible="ordersLength"> {{ $text.tr('ШАГ В %') }}</span><span v-visible="ordersLength"> {{ $text.tr('% ОТ ПОЗИЦ') }}</span>
                <template v-for="(order, index) in currentHook.Params.Tp.Orders">
                  <CustomInputNumber
                    :model.sync="order.Step"
                    :key="'tp-pct_' + index"
                    style="width: 100%;"
                    :max="100"
                  />
                  <CustomInputNumber
                    :model.sync="order.Pct"
                    :key="'tp-step_' + index"
                    style="width: 100%;"
                    :max="100"
                  />
                </template>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </main>
</template>

<script>
import CustomInputNumber from '@/components/common/CustomInputNumber.vue'
import hooks from '@/services/hooks'

export default {
  components: { CustomInputNumber },
  data () {
    return {
      url: 'https://hook.capico.app',
      showSetka: false,
      showStopLoss: false,
      showTakeProfit: false,
      ticker: '',
      exchanges: [],
      tpTrailingPctDefault: '1.0',
      minAmount: 15,
      maxLeverage: 50,
      maxSetkaQty: 4,
      maxTakeProfitQty: 8,
      isInputNumberError: false,
      inputErrorCount: 0,
      slcPeriods: [
        { min: 1, interval: '1m' },
        { min: 5, interval: '5m' },
        { min: 15, interval: '15m' },
        { min: 60, interval: '1h' },
        { min: 240, interval: '4h' },
        { min: 1440, interval: '1D' }
      ]
    }
  },
  watch: {
    currentHook: {
      deep: true,
      handler (newValue, oldValue) {
        if (this.isHookNameEmpty || this.inputErrorCount) {
          this.$store.state.hooks.isEditingHook = false
          return
        }

        if (oldValue.Id !== newValue.Id) {
          this.onChangeCurrentHook(newValue)
        } else {
          this.$store.state.hooks.isEditingHook = true
        }
      }
    }
  },
  computed: {
    isHookNameEmpty () {
      return !this.currentHook.Params.Name.trim()
    },
    currentHook () {
      return this.$store.getters.currentHook
    },
    ordersLength: {
      get () {
        return this.currentHook.Params.Tp.Orders.length
      },
      set (value) {
        this.currentHook.Params.Tp.Orders.length = 0
        const procent = parseFloat((100 / (2 * value)).toFixed(2))
        this.$forceUpdate()

        this.$nextTick(() => {
          for (let i = 0; i < value; i++) {
            this.currentHook.Params.Tp.Orders.push({
              Pct: procent,
              Step: procent
            })
          }
          this.$forceUpdate()
        })

        return value
      }
    },
    message () {
      return JSON.stringify(
        {
          id: `${this.currentHook.Id}.${this.currentHook.Secret}`,
          ticker: '{{ticker}}'
        },
        0,
        4
      )
    }
  },
  methods: {
    updateErrorCount (isError) {
      if (isError) {
        this.inputErrorCount += 1
        this.$store.state.hooks.isEditingHook = false
      } else if (this.inputErrorCount > 0) {
        this.inputErrorCount -= 1
      }

      if (this.inputErrorCount === 0) {
        this.$store.state.hooks.isEditingHook = true
      }
    },
    onChangeCurrentHook (newValue) {
      this.$store.state.hooks.isEditingHook = false
      this.$store.state.hooks.cashedCurrentHook = JSON.parse(
        JSON.stringify(newValue)
      )

      this.toggleSetkaSLTP()
    },
    toggleSetkaSLTP () {
      this.showSetka = Boolean(+this.currentHook.Params.Setka.Qty)
      this.showStopLoss = Boolean(+this.currentHook.Params.Sl.Step)
      this.showTakeProfit = Boolean(+this.currentHook.Params.Tp.Orders.length)
    },
    onChangeTpTrail () {
      this.currentHook.Params.Tp.TrailPct = this.tpTrailingPctDefault
    },
    returnExchUserName (etid) {
      const exchange = this.$store.state.sys.allexchanges.find(
        exch => exch.Id === etid
      )
      if (!exchange) {
        return ''
      }
      return exchange.Name
    },
    returnExchDemo (etid) {
      const exchange = this.$store.state.sys.allexchanges.find(
        exch => exch.Id === etid
      )
      if (exchange && exchange.Demo) {
        return true
      }
      return false
    },
    returnExchId (etid) {
      const exchange = this.$store.state.sys.allexchanges.find(
        exch => exch.Id === etid
      )
      if (!exchange) {
        return ''
      }
      if (exchange.Demo === true) {
        return 'Demo'
      }
      let exchName = ''
      switch (exchange.ExchId) {
        case 'BIM':
          exchName = 'Binance Margin'
          break
        case 'BIN':
          exchName = 'Binance'
          break
        case 'BIF':
          exchName = 'Binance Futures'
          break
        case 'EXM':
          exchName = 'Exmo'
          break
        case 'HUO':
          exchName = 'Huobi'
          break
        case 'FTX':
          exchName = 'FTX'
          break
      }
      return exchName
    },
    async sendTicker () {
      if (this.$store.state.hooks.isEditingHook) {
        await hooks.editHook(this.$store.getters.currentHook.Params)
      }

      const payload = {
        id: `${this.currentHook.Id}.${this.currentHook.Secret}`,
        ticker: this.ticker.trim(),
        test: '1'
      }

      hooks.sendTicker(payload)
    },
    removeHook () {
      hooks.removeHook(this.currentHook.Id)
    },
    saveHookChanges () {
      this.toggleSetkaSLTP()
      hooks.editHook(this.currentHook.Params)
    },
    duplicateHook () {
      const duplicatedHook = JSON.parse(
        JSON.stringify(this.$store.getters.currentHook)
      )
      duplicatedHook.Params.Id = ''
      duplicatedHook.Params.Active = false
      duplicatedHook.Params.Name = duplicatedHook.Params.Name + ' copy'

      hooks.editHook(duplicatedHook.Params)
    },
    clearSetka () {
      this.showSetka = !this.showSetka

      this.currentHook.Params.Setka.Qty = 0
      this.currentHook.Params.Setka.Mul = '0'
      this.currentHook.Params.Setka.Step = '0'
    },
    clearStopLoss () {
      this.showStopLoss = !this.showStopLoss

      this.currentHook.Params.Sl.Step = '0'
      this.currentHook.Params.Sl.Timeout = 0
      this.currentHook.Params.Sl.SlcPeriod = 0
    },
    clearTakeProfit () {
      this.showTakeProfit = !this.showTakeProfit

      if (this.showTakeProfit) {
        this.ordersLength = 1
      } else {
        this.ordersLength = 0
      }
    },
    copyToClipboard (text) {
      try {
        navigator.clipboard.writeText(text)
        this.$Notice.success({
          title: this.$text.tr('скопировано в буфер обмена')
        })
      } catch (e) {
        this.$Notice.error({
          title: this.$text.tr('ошибка копирования')
        })
      }
    },
    removeExchange (index) {
      this.currentHook.Params.Etids.splice(index, 1)
    },
    addAllExchanges () {
      this.currentHook.Params.Etids = this.$store.state.sys.allexchanges.map(
        exch => {
          return exch.Id
        }
      )
    }
  }
}
</script>
